import type { LicenseType } from 'model/hams/LicenseType';
import t from 'modules/i18n/intl';

type Props = {
  licenseType: LicenseType;
};

export default (props: Props) => {
  const labels = {
    COMMERCIAL: 'license.type.commercial',
    DEVELOPER: 'license.type.developer',
    OPEN_SOURCE: 'license.type.open_source',
    STARTER: 'license.type.starter',
    EVALUATION: 'license.type.evaluation',
    SOCIAL_IMPACT: 'license.type.social_impact',
    COMMUNITY: 'license.type.community',
  };

  return t(labels[props.licenseType] || 'license.type.commercial');
};
